import  { useGeoState } from '../../components/GeoProvider'
import { useFetchText } from '../../hooks/useFetchText'
import getVectorImage from '../../utils/getVectorImage'

const BelowMapNotification = ({message_type}) => {
    const { data: notification } = useFetchText('notification.json')
    if(message_type.toUpperCase()==='MONTHLY')
    {
      return notification?.vul_bnt !== undefined && (
      <div style={{fontSize:'12px',lineHeight:'15px',marginTop:'-36px',marginBottom:'-20px',display:'flex',color:'#828282'}}>
      <span> {getVectorImage('Info', '16px', '16px')}</span> &nbsp;&nbsp;
        <p>{notification?.vul_bnt}
      </p>
      </div>
    )
    }
    else
    {
      return notification?.flu_covid_rsv_aq !== undefined && (
      <div style={{fontSize:'12px',lineHeight:'15px',marginTop:'-36px',marginBottom:'-20px',display:'flex',color:'#828282'}}>
      <span> {getVectorImage('Info', '16px', '16px')}</span> &nbsp;&nbsp;
        <p>{notification?.flu_covid_rsv_aq}
      </p>
      </div>
    )
    }
    
}
export default BelowMapNotification